import {
  Snackbar,
  Alert,
  AlertTitle,
  Typography,
  SnackbarCloseReason,
} from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';

interface Props {
  openCondition: boolean;
  title: string | null;
  message: string;
  success?: boolean;
  error?: boolean;
  handleClose?: () => void;
}

const InfoPopup = ({
  openCondition,
  title,
  message,
  success,
  error,
  handleClose,
}: Props) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  useEffect(() => {
    if (openCondition) setSnackbarOpen(true);
  }, [openCondition]);
  const handleAlertClose = (
    event: SyntheticEvent<any> | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
    if (handleClose) handleClose();
  };
  return (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={success ? 3000 : 5000}
      onClose={handleAlertClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      style={{ zIndex: 9999999, top: 90 }}
    >
      <Alert
        onClose={handleAlertClose}
        severity={success ? 'success' : error ? 'error' : 'info'}
        variant='filled'
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        <Typography variant='body2'>{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default InfoPopup;
